const state = () => ({})

const getters = {}

const actions = {
    async types() {
        const res = await this._vm.axios.get(this._vm.endpoints['stock_unit'])
        const {data} = res.data

        return data;
    },

    // refresh records
    refresh({dispatch}) {
        dispatch('get');
    }
}

const mutations = {}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}